import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { NewSectionInner } from '../../';

export const NavigationContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid rgb(255 255 255 / 0.04);
  background-color: ${({ theme }) => theme.footerColor};
  ${fontSmoothing}
`;

export const NavigationInner = styled(NewSectionInner)`
  padding-top: 0;
  padding-bottom: 0;
`;
